var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"left-0 my-0 mx-auto max-w-[25rem] overflow-hidden absolute right-0 text-center top-4 z-[9999]",attrs:{"name":"toast-fade","tag":"div"}},_vm._l((_vm.snackMessages),function(snackMessage){return _c('woot-snackbar',{key:snackMessage.key,attrs:{"message":snackMessage.message,"action":snackMessage.action}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }